<template>
  <div >
    <banner title="数字化平台" imgUrl="https://manybox.oss-cn-shanghai.aliyuncs.com/officialWebsite/banner2.png" text="沃时派客是国内领先的数字化包装管理创新平台"></banner>
    <div class="contentBox">
      <div class="box">
        <div class="title">数据驱动，全数字化服务</div>
        <p class="text">全球供应链面临的风险因素的增加，使得传统包装供应体系不能作出快速反应，无法及时满足供应的基本需求为解决单一供应链的不足，亟需由传统供应链转变为共享供应网络</p>
        <img src="@/assets/bigScreen.png">
      </div>
    </div>
    <div class="contentBox2">
      <div class="tabs">
        <div @click="backTop(1)" class="tab" :style="{'border-color': active==1 ? '#3359CC' : '#fff' ,'color':active==1 ? '#333' : '#9699A1'}">供应保证</div>
        <el-divider direction="vertical"></el-divider>
        <div @click="backTop(2)" class="tab" :style="{'border-color': active==2 ? '#3359CC' : '#fff' ,'color':active==2 ? '#333' : '#9699A1' }">成本降低</div>
      </div>
    </div>
    <tab1 v-if="active == 1"></tab1>
    <tab2 v-if="active == 2"></tab2>

  </div>
</template>

<script>
import banner from './banner.vue'
import tab1 from './tabs/tab1.vue'
import tab2 from './tabs/tab2.vue'

export default {
  components: {
    banner,
    tab1,
    tab2
  },
  data() {
    return {
      scrollTop: 0,
      active: 1,
      imgList: [
        { url: require("@/assets/services/1.png"), id: "img0" },
        { url: require("@/assets/services/3.png"), id: "img1" },
        { url: require("@/assets/services/2.png"), id: "img2" }
      ],
      fontDisplay: true
    };
  },
  mounted() {
    this.position()
  },
  watch: {
    '$route': function (to) {
      if (to.path == '/services') {
        this.position()
      }
    }
  },
  methods: {
    position() {
      if (this.$route.query.anchorPoint == 'promise') {
          this.animation(1136)
          this.active = 1
        } else if (this.$route.query.anchorPoint == 'cost') {
          this.animation(1136)
          this.active = 2
        }
    },
    animation(val) {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.scrollTop < val) {
            let tmp = val - this.scrollTop
            this.scrollTop = this.scrollTop + (tmp > 100 ? 100 : tmp)
          }
          document.body.scrollTop = this.scrollTop
          document.documentElement.scrollTop = this.scrollTop
          this.scrollTop < val ? this.animation(val) : this.scrollTop = 0
        }, 10);
      })
    },
    backTop(val) {
      this.active = val
      document.body.scrollTop = 1125
      document.documentElement.scrollTop = 1125
    }
  }
};
</script>

<style lang="less" scoped>
.contentBox {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 80px 0 35px 0;
  .box {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 1200px;
    text-align: center;
    .title {
      font-size: 42px;
      font-weight: 500;
    }
    p {
      width: 784px;
      font-weight: 500;
      color: #999999;
      line-height: 19px;
      margin: 24px 0 64px 0;
    }
    img {
      width: 721px;
      height: 406px;
    }
  }
}
.contentBox2 {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
  background-color: #fff;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 99;
  border-bottom: 1px solid #eee;

  .tabs {
    width: 552px;
    display: flex;
    justify-content: space-between;
    font-size: 24px;
    .tab {
      color: #9699a1;
      border-bottom: 4px solid;
      padding-bottom: 19px;
      cursor: pointer;
    }
  }
}
</style>
